import React, { useState, useEffect } from "react";
import { Container, Navbar } from "react-bootstrap";
import { useNavigate, useLocation } from "react-router-dom";

const Header = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  const handleFeatureClick = () => {
    if (window.location.pathname === "/") {
      document
        .getElementById("features")
        ?.scrollIntoView({ behavior: "smooth" });
    } else {
      navigate("/#features");
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const menuItems = [
    { name: "Home", path: "/" },
    { name: "Features", path: "/features" },
    { name: "Pricing", path: "/pricing" },
    { name: "Blog", path: "/blog" },
    { name: "Contact", path: "/contact" },
  ];

  const handleNavigation = (path) => {
    navigate(path);
    setIsMenuOpen(false);
  };

  return (
    <>
      <style>{`
        .navbar-glass {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          z-index: 1000;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(0, 0, 0, 0.06);
          padding: 12px 0;
          transition: all 0.3s ease;
        }
        
        .navbar-glass.scrolled {
          background: rgba(255, 255, 255, 0.98);
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.08);
        }
        
        .logo-wrapper {
          display: flex;
          align-items: center;
          gap: 10px;
          cursor: pointer;
        }
        
        .logo-img {
          width: 32px;
          height: 32px;
          border-radius: 8px;
          object-fit: contain;
        }
        
        .logo-text {
          font-size: 20px;
          font-weight: 700;
          color: #0f1720;
          margin: 0;
        }
        
        /* Desktop Navigation */
        .nav-menu {
          display: flex;
          align-items: center;
          gap: 32px;
        }
        
        .nav-link-custom {
          color: #495a6b;
          text-decoration: none;
          font-size: 15px;
          font-weight: 500;
          transition: color 0.3s;
          cursor: pointer;
          background: none;
          border: none;
          padding: 0;
        }
        
        .nav-link-custom:hover {
          color: #0f1720;
        }
        
        .nav-actions {
          display: flex;
          align-items: center;
          gap: 16px;
        }
        
        .btn-signin {
          color: #495a6b;
          background: none;
          border: none;
          font-size: 15px;
          font-weight: 500;
          padding: 8px 16px;
          transition: color 0.3s;
        }
        
        .btn-signin:hover {
          color: #0f1720;
        }
        
        .btn-get-started {
          background: #1b2a41;
          color: white;
          border: none;
          padding: 10px 20px;
          border-radius: 10px;
          font-size: 15px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.3s;
        }
        
        .btn-get-started:hover {
          background: #2a3a51;
          transform: translateY(-2px);
        }
        
        /* Hamburger Menu - Hidden on Desktop */
        .hamburger-menu {
          display: none;
          width: 40px;
          height: 40px;
          background: none;
          border: none;
          cursor: pointer;
          position: relative;
          padding: 0;
        }
        
        .hamburger-line {
          display: block;
          width: 24px;
          height: 2px;
          background: #1a1a1a;
          margin: 5px auto;
          transition: all 0.3s ease;
        }
        
        .hamburger-menu.active .hamburger-line:nth-child(1) {
          transform: translateY(7px) rotate(45deg);
        }
        
        .hamburger-menu.active .hamburger-line:nth-child(2) {
          opacity: 0;
        }
        
        .hamburger-menu.active .hamburger-line:nth-child(3) {
          transform: translateY(-7px) rotate(-45deg);
        }
        
        /* Mobile Sidebar */
        .mobile-sidebar {
          position: fixed;
          top: 0;
          right: -100%;
          width: 80%;
          max-width: 360px;
          height: 100vh;
          background: white;
          box-shadow: -4px 0 20px rgba(0, 0, 0, 0.1);
          transition: right 0.3s ease;
          z-index: 1001;
        }
        
        .mobile-sidebar.open {
          right: 0;
        }
        
        .sidebar-header {
          padding: 20px;
          border-bottom: 1px solid #f0f0f2;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
        
        .sidebar-logo {
          font-size: 18px;
          font-weight: 600;
          color: #1a1a1a;
        }
        
        .close-btn {
          background: none;
          border: none;
          font-size: 24px;
          color: #6b7280;
          cursor: pointer;
          padding: 0;
          width: 32px;
          height: 32px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .sidebar-content {
          padding: 20px;
        }
        
        .sidebar-nav {
          list-style: none;
          padding: 0;
          margin: 0;
        }
        
        .sidebar-nav-item {
          padding: 16px 20px;
          margin: 0 -20px;
          border-bottom: 1px solid #f5f5f7;
          cursor: pointer;
          transition: all 0.2s;
          font-size: 16px;
          color: #374151;
        }
        
        .sidebar-nav-item:hover {
          background: #f9fafb;
          padding-left: 24px;
        }
        
        .sidebar-actions {
          margin-top: 40px;
          padding-top: 20px;
          border-top: 1px solid #f0f0f2;
        }
        
        .sidebar-btn {
          width: 100%;
          padding: 14px;
          margin-bottom: 12px;
          border-radius: 10px;
          font-size: 16px;
          font-weight: 500;
          cursor: pointer;
          transition: all 0.3s;
        }
        
        .sidebar-signin {
          background: white;
          border: 1px solid #e5e7eb;
          color: #374151;
        }
        
        .sidebar-signin:hover {
          background: #f9fafb;
        }
        
        .sidebar-get-started {
          background: #1b2a41;
          border: none;
          color: white;
        }
        
        .sidebar-get-started:hover {
          background: #2a3a51;
        }
        
        /* Overlay */
        .sidebar-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background: rgba(0, 0, 0, 0.5);
          opacity: 0;
          visibility: hidden;
          transition: all 0.3s;
          z-index: 999;
        }
        
        .sidebar-overlay.active {
          opacity: 1;
          visibility: visible;
        }
        
        /* Mobile Responsive */
        @media (max-width: 768px) {
          .nav-menu,
          .nav-actions {
            display: none;
          }
          
          .hamburger-menu {
            display: block;
          }
          
          .navbar-glass {
            padding: 10px 0;
          }
        }

        html {
  scroll-behavior: smooth;
}


#features {
  scroll-margin-top: 100px; /* header高度 + 一些间距 */
}


      `}</style>

      <Navbar className={`navbar-glass ${scrolled ? "scrolled" : ""}`}>
        <Container>
          <div className="d-flex align-items-center justify-content-between w-100">
            {/* Logo */}
            <div className="logo-wrapper" onClick={() => navigate("/")}>
              <img
                src="/assets/logocity.jpg"
                alt="CityGetAway"
                className="logo-img"
              />
              <span className="logo-text">CityGetAway</span>
            </div>

            {/* Desktop Navigation Menu */}
            <div className="nav-menu">
              <button className="nav-link-custom" onClick={handleFeatureClick}>
                Features
              </button>

              <button
                className="nav-link-custom"
                onClick={() => navigate("/pricing")}
              >
                Pricing
              </button>
              <button
                className="nav-link-custom"
                onClick={() => navigate("/blog")}
              >
                Blog
              </button>
              <button
                className="nav-link-custom"
                onClick={() => navigate("/contact")}
              >
                Contact
              </button>
            </div>

            {/* Desktop Actions */}
            <div className="nav-actions">
              <button className="btn-signin" onClick={() => navigate("/login")}>
                Sign In
              </button>
              <button
                className="btn-get-started"
                onClick={() => navigate("/city-selection")}
              >
                Get Started
                <i className="bi bi-arrow-right"></i>
              </button>
            </div>

            {/* Hamburger Menu for Mobile */}
            <button
              className={`hamburger-menu ${isMenuOpen ? "active" : ""}`}
              onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
              <span className="hamburger-line"></span>
            </button>
          </div>
        </Container>
      </Navbar>

      {/* Mobile Sidebar */}
      <div className={`mobile-sidebar ${isMenuOpen ? "open" : ""}`}>
        <div className="sidebar-header">
          <div className="sidebar-logo">CityGetAway</div>
          <button className="close-btn" onClick={() => setIsMenuOpen(false)}>
            <i className="bi bi-x"></i>
          </button>
        </div>

        <div className="sidebar-content">
          <nav className="sidebar-nav">
            {menuItems.map((item) => (
              <div
                key={item.path}
                className="sidebar-nav-item"
                onClick={() => handleNavigation(item.path)}
              >
                {item.name}
              </div>
            ))}
          </nav>

          <div className="sidebar-actions">
            <button
              className="sidebar-btn sidebar-signin"
              onClick={() => handleNavigation("/login")}
            >
              Sign In
            </button>
            <button
              className="sidebar-btn sidebar-get-started"
              onClick={() => handleNavigation("/city-selection")}
            >
              Get Started
            </button>
          </div>
        </div>
      </div>

      {/* Overlay */}
      <div
        className={`sidebar-overlay ${isMenuOpen ? "active" : ""}`}
        onClick={() => setIsMenuOpen(false)}
      ></div>
    </>
  );
};

export default Header;
